<script>
const TOGGLE_TRANSITION = 350;



export default {
  name: 'dn-top-part',

  props: {
    index: Number,
    id: {
      type: String,
      required: true,
    },
    label: String,
    description: String,
    groups: Array,
    notes: String,
    status: String,
    plain: Boolean,
  },

  data() {
    return {
      opend: true,
      nowTransition: false,
    }
  },

  computed: {
    isOpen() { return dn.$store.getters['mq/pc'] || this.opend },
    bodyStyles() {
      return this.nowTransition && {
        transition: TOGGLE_TRANSITION + 'ms',
      }
    },
  },

  methods: {
    clearTransitionEndWatcher() {
      if (this.transitionEndWatcherId) {
        clearTimeout(this.transitionEndWatcherId);
        delete this.transitionEndWatcherId;
        this.nowTransition = false;
      }
    },

    toggle() {
      if (!dn.$store.getters['mq/sp']) return;
      this.clearTransitionEndWatcher();
      this.nowTransition = true;
      this.$nextTick(() => {
        this.opend = !this.opend;
        this.transitionEndWatcherId = setTimeout(() => {
          this.clearTransitionEndWatcher();
        }, TOGGLE_TRANSITION + 100);
      });
    },

    genStatus(h = this.$createElement) {
      return h('p', {staticClass: 'pg-item__status'}, this.$status.display(this.status));
    },

    genHeader(h = this.$createElement) {
      return h('div', {
        staticClass: 'pg-item__header',
        on: {
          click: this.toggle,
        },
      }, [
        h('h3', {
          staticClass: 'pg-item__name',
          domProps: {
            innerHTML: this.label,
          },
        }),
        this.genStatus(),
        h('dn-icon', {props: {icon: 'arrow-down'}}),
      ]);
    },

    genDescription(h = this.$createElement) {
      return h('p', {
        staticClass: 'pg-item__description',
        domProps: {
          innerHTML: this.description,
        },
      });
    },

    genLinks(h = this.$createElement) {
      return this.groups.map(group => {
        const children = [];
        if (group.label) {
          children.push(h('h4', {
            attrs: {
              'data-label': '',
            },
            domProps: {
              innerHTML: group.label,
            },
          }));
        }
        const links = group.links.map(link => {
          const attrs = {
            href: link.href,
          };
          if (link.target) attrs.target = link.target;

          const directives = link.url_id ? [{ name: 'linkset', value: link.url_id }] : undefined;

          const linkChildren = [h('span', {
              domProps: {
                innerHTML: link.label,
              },
          })];

          if (!this.plain) {
            linkChildren.push(h('dn-icon', {
              props: {
                icon: 'arrow-right',
              },
            }));
          }

          return h('a', {
            class: {
              'pg-item__link': !this.plain,
              'pg-item__link--auth': !this.plain && link.auth,
            },
            attrs,
            directives,
          }, linkChildren)
        });

        if (this.plain) {
          children.push(...links);
        } else {
          const $linksBody = h('div', {
            staticClass: 'pg-item__links',
            class: {
              'pg-item__links--labeled': !!group.label,
            },
          }, links);
          children.push($linksBody);
        }
        return children;
      });
    },

    genBody(h = this.$createElement) {
      const children = [];
      if (this.description) children.push(this.genDescription());
      children.push(this.genStatus());
      children.push(...this.genLinks());
      children.push(this.$slots.default);

      return h('dn-expand-transition', undefined, [
        h('div', {
          staticClass: 'pg-item__body',
          style: this.bodyStyles,
          directives: [
            { name: 'show', value: this.isOpen },
          ],
        }, [
          h('div', {
            staticClass: 'pg-item__body__inner',
          }, children),
        ])
      ]);
    },
  },

  render(h) {
    return h('div', {
      staticClass: 'pg-item-frame',
      attrs: {
        'data-index': this.index,
      },
    }, [
      h('div', {
        staticClass: 'pg-item',
        class: {
          [`pg-item--${this.id}`]: true,
        },
      }, [
        this.genHeader(),
        this.genBody(),
      ]),
    ]);
  },
}
</script>



// WEBPACK FOOTER //
// TopPart.vue?05cd62c6